import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { Amplify } from 'aws-amplify'
import App from './App'
import { theme } from './theme'
import { awsConfig } from './config/aws'
import { FeedbackProvider } from './context/FeedbackContext'
import ScreenshotBanner from './components/feedback/ScreenshotBanner'

Amplify.configure(awsConfig)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <FeedbackProvider>
        <ScreenshotBanner />
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </FeedbackProvider>
    </ThemeProvider>
  </React.StrictMode>
)
